import React from "react";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Translate } from "orion-components/i18n";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";

const AlertDialog = ({ isOpen, alertData, toggleDialogOpen }) => {
	const [openDialog, setOpenDialog] = useState(false);
	const dir = useSelector((state) => getDir(state));

	useEffect(() => {
		setOpenDialog(isOpen);
	}, [isOpen]);

	return (
		<div
			style={{
				display: openDialog ? "block" : "none",
				backgroundColor: "transparent",
				color: "#fff",
				width: 118,
				marginBottom: "-8px"
			}}
		>
			<div
				style={{
					...(dir === "ltr" && { marginLeft: "-54px" }),
					...(dir === "rtl" && { marginRight: "-54px" }),
					width: "100%",
					height: "auto",
					backgroundColor: "#1D1D1F"
				}}
				onMouseLeave={() => {
					toggleDialogOpen(false);
				}} data-testid="orion-components-cbcomponents-new-video-player-components-recorded-alerts-alert-dialog-div"
			>
				<div
					style={{
						paddingTop: 10.07,
						...(dir === "ltr" && { paddingLeft: 10 }),
						...(dir === "rtl" && { paddingRight: 10 }),
						marginBottom: 13,
						fontSize: 7
					}}
				>
					<div style={{ fontWeight: "bold", fontSize: "1em", height: 10 }}>{alertData?.name ?? ""}</div>
					<div style={{ fontSize: "1em", height: 10 }}>
						<Translate value="global.CBComponents.newVideoPlayer.components.recorded.alarms.alarmDialog.date" />
						: {moment(alertData.createdDate).format("MM/DD/YYYY")}
					</div>
					<div style={{ fontSize: "1em", height: 10 }}>
						<Translate value="global.CBComponents.newVideoPlayer.components.recorded.alarms.alarmDialog.time" />
						: {moment(alertData.createdDate).format("HH:mm:ss")}
					</div>
				</div>
				<div
					style={{
						...(dir === "ltr" && { paddingLeft: 10 }),
						...(dir === "rtl" && { paddingRight: 10 }),
						paddingBottom: 15,
						fontSize: 8
					}}
				>
					<Button
						sx={{
							color: "#fff",
							fontSize: "1em",
							width: 97,
							height: 17
						}}
						color="primary"
						variant="contained" data-testid="orion-components-cbcomponents-new-video-player-components-recorded-alerts-alert-dialog-button"
					>
						<Translate value="global.CBComponents.newVideoPlayer.components.recorded.alarms.alarmDialog.openSituation" />
					</Button>
				</div>
			</div>
			<div
				style={{
					...(dir === "ltr" && { marginLeft: "-16px" }),
					...(dir === "rtl" && { marginRight: "-16px" }),
					transform: "rotate(180deg)",
					width: 0,
					height: 0,
					borderLeft: "20px solid transparent",
					borderRight: "20px solid transparent",
					borderBottom: "35px solid #1D1D1F"
				}}
			></div>
		</div>
	);
};

AlertDialog.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	alertData: PropTypes.shape({
		name: PropTypes.string,
		createdDate: PropTypes.string
	}).isRequired,
	toggleDialogOpen: PropTypes.func
};

export default AlertDialog;
